// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as BlacklistingReasonsApiModel from "../api-model/BlacklistingReasonsApiModel.bs.js";

function decodeApiModel(json) {
  return {
          blacklisting_reasons: Belt_List.map(Belt_List.fromArray(json.blacklisting_reasons), (function (reason) {
                  return {
                          id: reason.id,
                          description: reason.description,
                          show_for_manual_blacklisting: reason.show_for_manual_blacklisting,
                          blacklist_type: reason.blacklist_type,
                          reason: reason.reason_enum
                        };
                }))
        };
}

function execute(json) {
  return decodeApiModel(DeccoUtils$Catalyst.resolveResult(BlacklistingReasonsApiModel.t_decode(json), "BlacklistingReasons.res"));
}

export {
  decodeApiModel ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
